import { ErrorViewModel,
         EventBus,
         MessageEntity,
         ConversationSessionEntity,
         AttachmentSatisfactionEntity,
         AttachmentTypeEnum,
         NotificationEntity,
         IConversationState }                   from '../../..';

export interface IConversationMutations {
  SEND_MESSAGE_REQUEST_IN_PROGRESS(state: IConversationState): void;
  SEND_MESSAGE_SAT_REQUEST_IN_PROGRESS(state: IConversationState): void;
  INIT_CONVERSATION(state: IConversationState, conversationSession: ConversationSessionEntity): void;
  REGISTER_MESSAGE_SENT(state: IConversationState, message: MessageEntity): void;
  REGISTER_MESSAGES_BOT_ANSWER_SUCCESS(state: IConversationState, messages: MessageEntity[]): void;
  REGISTER_ON_ERROR_SERVER_NOTIFICATION(state: IConversationState, error: ErrorViewModel): void;
  REGISTER_SATISFACTION_FEEDBACK_DONE(state : IConversationState,payload:any): void;
  ADD_TO_NOTIFICATIONS(state : IConversationState,notifications: NotificationEntity[]): void;
  RESET_NOTIFICATIONS(state : IConversationState): void;
  MARK_NOTIF_AS_SEEN(state : IConversationState, notifId: string): void;
}

export const ConversationMutations: IConversationMutations = {
  SEND_MESSAGE_REQUEST_IN_PROGRESS: (state: IConversationState) => {
    state.isLoading = true;
    state.error = undefined;
    state.isRequestSucceed = false;
  },
  SEND_MESSAGE_SAT_REQUEST_IN_PROGRESS: (state: IConversationState) => {
    state.isSatReqLoading = true;
    state.error = undefined;
  },
  REGISTER_ON_ERROR_SERVER_NOTIFICATION: (state: IConversationState, error: ErrorViewModel) => {
    state.isLoading = false;
    state.isSatReqLoading = false;
    state.error = error;
    state.isRequestSucceed = false;
  },
  REGISTER_MESSAGE_SENT: (state: IConversationState, message: MessageEntity) => {
    if (state.currentConversation) {
      state.currentConversation.currentDialog.addNewMessage(message);
    }
  },
  REGISTER_MESSAGES_BOT_ANSWER_SUCCESS: (state: IConversationState, messages: MessageEntity[]) => {
    state.isLoading = false;
    state.error = undefined;
    state.isRequestSucceed = true;
    if (state.currentConversation) {
      state.currentConversation.currentDialog.addNewMessages(messages);
    }
  },
  INIT_CONVERSATION: (state: IConversationState, conversationSession: ConversationSessionEntity) => {
    state.isLoading = false;
    state.error = undefined;
    state.isRequestSucceed = true;
    state.currentConversation = conversationSession;
  },
  REGISTER_SATISFACTION_FEEDBACK_DONE: (state: IConversationState, payload: any) => {
    state.isSatReqLoading = false;
    state.error = undefined;
    state.isRequestSucceed = true;

    const messages = state.currentConversation?.currentDialog.messages.filter(msg => { 
      return msg.msgId == payload.messageId || (!payload.messageId.endsWith("_0") && msg.msgId.split("_")[0] == payload.messageId.split("_")[0])
    });

    if (messages && messages[0]) {
      if (messages[0].displayableResponses) {
        const displayableResponse = messages[0].displayableResponses.filter(msg => { return msg.msgId == payload.messageId})
        if (displayableResponse && displayableResponse[0]) {
          const att: AttachmentSatisfactionEntity[] = <AttachmentSatisfactionEntity[]> displayableResponse[0].attachments?.get(AttachmentTypeEnum.SATISFACTION_QUESTION);
          if (att && att[0]) {
            att[0].buttons.filter(btn => { return btn.id == payload.satisfactionId }).map(btn => { btn.alreadyClicked = true });
          }
        }
      } else {
        const att: AttachmentSatisfactionEntity[] = <AttachmentSatisfactionEntity[]> messages[0].attachments?.get(AttachmentTypeEnum.SATISFACTION_QUESTION);
        if (att && att[0]) { 
          att[0].buttons.filter(btn => { return btn.id == payload.satisfactionId }).map(btn => { btn.alreadyClicked = true });
        }
      }
    }
    EventBus.$emit('ON_SATISFACTION_FEEDBACK_DONE');
  },
  ADD_TO_NOTIFICATIONS: (state: IConversationState, notifications: NotificationEntity[]) => {
    
    state.notifications = state.notifications.concat(notifications)
  },
  RESET_NOTIFICATIONS: (state: IConversationState) => {
    for (const notif of state.notifications) {
      if(notif.seen){
        notif.toShow = false;
      }
    }
  },
  MARK_NOTIF_AS_SEEN : (state: IConversationState, notifId : string) => {
    for (const notif of state.notifications){
      if (notif.id == notifId){
        notif.seen = true;
      }
    }
  }
};